// extracted by mini-css-extract-plugin
export default {"Container":"TeamInfo_Container__7tRKU","Logo":"TeamInfo_Logo__bB7-d","Title":"TeamInfo_Title__lhQpv"};